import { connect } from 'react-redux';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import { selectTotalFiltersApplied } from 'src/components/organisms/Filter/modules/selectors/selectors';
import { NoSearchResultsGuard } from 'src/components/organisms/NoSearchResultsGuard/components/NoSearchResultsGuard';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectTotalProducts } from 'src/redux/products/selectors';

export const mapStateToProps = (state: ReduxApplicationState) => {
  const totalProducts = selectTotalProducts(state);
  const totalFiltersApplied = selectTotalFiltersApplied(state);

  return {
    onMessageVisible: () => {
      sendGAEvent({
        event: 'custom_event',
        event_category: 'Search page',
        event_action: 'zero search results',
        event_label: state.products.searchTerm,
      });
    },
    showNoSearchResultsMessage: totalProducts === 0 && totalFiltersApplied === 0,
    searchTerm: state.products.searchTerm,
  };
};

export const NoSearchResultsGuardContainer = connect(mapStateToProps)(NoSearchResultsGuard);
